import {TrainingSpecialitiesDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'CREATE_CUSTOMER_CATEGORY';

export async function createTrainingSpeciality(
    userData: Record<string, string>,
    trainingSpecialty: Record<string, any>
) {
    try {
        const result = await TrainingSpecialitiesDao.createTrainingSpecialty(userData.userToken, trainingSpecialty);

        return result;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
